import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import PopupOverlay from "../Background/PopupOverlay";
import Button from "../../atoms/Button";
import "./BandBoardPanel.scss";

export default function BandBoardListModal({
    isOpen,
    list,
    onClose,
    onSubmit,
    isSubmitting = false,
    error,
}) {
    const { t } = useTranslation();
    const [name, setName] = useState("");

    useEffect(() => {
        if (!isOpen) {
            return;
        }
        setName(list?.name || "");
    }, [isOpen, list]);

    if (!isOpen) {
        return null;
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        onSubmit?.({
            name: name.trim(),
        });
    };

    const isNameValid = name.trim().length > 0 && name.trim().length <= 140;

    return ReactDOM.createPortal(
        <PopupOverlay onClose={onClose} closeOnOverlayClick closeOnEsc>
            <div
                className="band-board-list-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="groupBoardListModalTitle"
            >
                <header className="band-board-list-modal__header">
                    <h2 id="groupBoardListModalTitle">{t("bandsPage.board.listModal.title")}</h2>
                    <button
                        type="button"
                        className="band-board-list-modal__close"
                        onClick={onClose}
                        aria-label={t("bandsPage.common.closeButton")}
                        disabled={isSubmitting}
                    >
                        ×
                    </button>
                </header>
                <form className="band-board-list-modal__form" onSubmit={handleSubmit}>
                    <label className="band-board-list-modal__field">
                        <span>{t("bandsPage.board.listModal.fieldLabel")}</span>
                        <input
                            value={name}
                            onChange={(event) => setName(event.target.value)}
                            placeholder={t("bandsPage.board.listModal.fieldPlaceholder")}
                            maxLength={140}
                            disabled={isSubmitting}
                        />
                    </label>
                    {error && (
                        <p className="band-board-list-modal__error" role="alert">
                            {error}
                        </p>
                    )}
                    <div className="band-board-list-modal__actions">
                        <Button
                            type="button"
                            variant="secondary"
                            text={t("bandsPage.board.listModal.actions.cancel")}
                            onClick={onClose}
                            disabled={isSubmitting}
                        />
                        <Button
                            type="submit"
                            variant="primary"
                            text={isSubmitting ? t("bandsPage.board.listModal.actions.saving") : t("bandsPage.board.listModal.actions.save")}
                            disabled={!isNameValid || isSubmitting}
                        />
                    </div>
                </form>
            </div>
        </PopupOverlay>,
        document.getElementById("portal")
    );
}

BandBoardListModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    list: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
    }),
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    isSubmitting: PropTypes.bool,
    error: PropTypes.string,
};

BandBoardListModal.defaultProps = {
    list: null,
    isSubmitting: false,
    error: "",
};
